/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type MailboxImapCreateRequestSmtpSecurity = typeof MailboxImapCreateRequestSmtpSecurity[keyof typeof MailboxImapCreateRequestSmtpSecurity];


export const MailboxImapCreateRequestSmtpSecurity = {
  TLS: 'TLS',
  STARTTLS: 'STARTTLS',
  NONE: 'NONE',
} as const;
